import styled from 'styled-components';

const DateRangePickerMLStyled = styled('div')`
  .MuiDateRangePickerInput-root {
    .MuiFormHelperText-root {
      display: none;
    }
  }
`;

export default DateRangePickerMLStyled;
